import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const ListIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="0vc5pe1mya">
          <path d="M1920 0v1080H0V0h1920z" />
        </clipPath>
        <clipPath id="7i801otghb">
          <path d="M30 20a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0-10a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0-10a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z" />
        </clipPath>
      </defs>
      <g clipPath="url(#0vc5pe1mya)" transform="translate(-264 -315)">
        <g clipPath="url(#7i801otghb)" transform="translate(264 319)">
          <path d="M0 0h32v24H0V0z" />
        </g>
      </g>
    </svg>
  )
})
